import { render, staticRenderFns } from "./GeoRestrictions.vue?vue&type=template&id=d96605e4&"
import script from "./GeoRestrictions.vue?vue&type=script&lang=js&"
export * from "./GeoRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./GeoRestrictions.vue?vue&type=style&index=0&id=d96605e4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports